<template>
  <div>
    <BatchTable
      :orderInspectionCode="orderInspectionCode"
      :orderCode="orderCode"
      :disabled="disabled"
      @reload="$emit('reload')"
      isExpand
    />
  </div>
</template>
<script>
import BatchTable from '../batch-table'
export default {
  components: { BatchTable },
  props: {
    orderInspectionCode: String,
    orderCode: String,
    disabled: { type: Boolean, default: false },
  },
}
</script>
